<template>
  <el-dialog
    v-model="dialogFormVisible"
    :title="title"
    width="70%"
    @close="close"
  >
    <el-form ref="form" label-width="150px" :model="form" :rules="rules">
      <el-form-item label="会员等级标题" prop="title">
        <el-input v-model.trim="form.title" class="custom-form-item" />
      </el-form-item>
      <el-form-item label="排序" prop="order">
        <el-input-number
          v-model="form.order"
          class="custom-form-item"
          :min="0"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { addLevel, editLevel } from '@/api/people'
  import { uploadURL } from '@/config/net.config'

  export default {
    name: 'PeopleLevelEdit',
    emits: ['fetch-data'],
    data() {
      return {
        uploadURL,
        form: {
          title: '',
          cardFace: '',
          upgradeCard: '',
          color: '',
          useText: '',
          vipRights: '',
          text: '',
          order: 0,
        },
        rules: {
          title: [
            { required: true, trigger: 'blur', message: '请填写会员等级' },
          ],
        },
        title: '',
        dialogFormVisible: false,
        customCardFace: false,
        customUpgradeCard: false,
        predefineColors: [
          '#FF5B45',
          '#999999',
          '#E3B56B',
          '#BFAC90',
          '#212121',
          '#79d5d3',
        ],
      }
    },
    methods: {
      showEdit(row) {
        if (!row) {
          this.title = '新增会员等级'
          this.customCardFace = false
          this.customUpgradeCard = false
        } else {
          this.title = '修改会员等级'
          this.form = Object.assign(
            {},
            {
              title: row.title || '',
              levelId: row.levelId || '',
              cardFace: row.basic.cardFace || '',
              upgradeCard: row.basic.upgradeCard || '',
              color: row.basic.color || '',
              useText: row.basic.useText || '',
              vipRights: row.basic.vipRights || '',
              text: row.basic.text || '',
              order: row.basic.order || 0,
            }
          )
          this.customCardFace = !!row.basic.cardFace
          this.customUpgradeCard = !!row.basic.upgradeCard
        }
        this.dialogFormVisible = true
      },
      close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
      },
      save() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            await (this.form.levelId
              ? editLevel(this.form)
              : addLevel(this.form))
            this.$baseMessage(
              this.form.levelId ? '修改等级成功' : '新增等级成功',
              'success',
              false,
              'vab-hey-message-success'
            )
            this.$emit('fetch-data')
            this.close()
          } else {
            return false
          }
        })
      },
      handleAvatarSuccess(res) {
        if (res.code) {
          this.$message.error({
            message: res.message,
          })
          return
        }
        this.form.cardFace = res.data.url
      },
      handleCardSuccess(res) {
        if (res.code) {
          this.$message.error({
            message: res.message,
          })
          return
        }
        this.form.upgradeCard = res.data.url
      },
      beforeImgUpload(file) {
        const isJPG = file.type === 'image/jpeg'
        const isPNG = file.type === 'image/png'
        const isLt500K = file.size / 1024 / 1024 < 0.5

        if (!isJPG && !isPNG) {
          this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
        }
        if (!isLt500K) {
          const h = this.$createElement
          this.$message({
            message: h('p', { style: 'color: #F56C6C; font-size: 14px;' }, [
              h('span', null, '上传图片大小不能超过 500KB! '),
              h(
                'a',
                {
                  style: 'color: #409EFF',
                  attrs: { href: 'https://tinypng.com', target: '_blank' },
                },
                '立即压缩'
              ),
            ]),
            type: 'error',
          })
        }
        return (isJPG || isPNG) && isLt500K
      },
    },
  }
</script>

<style lang="scss" scoped>
  @mixin sizeAvatar($scale: 1) {
    width: 620px * $scale;
    height: 320px * $scale;
  }
  @mixin upgradeAvatar($scale: 1) {
    width: 620px * $scale;
    height: 320px * $scale;
  }
  .upgrade-avatar {
    @include upgradeAvatar(0.5);
  }
  .card-face {
    @include sizeAvatar(0.5);
  }
  .share-avatar {
    @include sizeAvatar(0.5);
    margin: 0 auto;
  }
  .config-list {
    .config-item {
      display: flex;
      align-items: center;
      padding: 10px 15px;

      .config-item_input {
        display: inline-block;
        width: 20%;
      }
    }
  }
  .config-btns {
    padding: 10px 15px;
  }

  .el-icon-circle-plus-outline,
  .el-icon-remove-outline {
    font-size: 32px;
    vertical-align: middle;
    cursor: pointer;
  }

  .el-icon-circle-plus-outline {
    color: #409eff;
  }

  .el-icon-remove-outline {
    margin-left: 15px;
    color: #f56c6c;
  }
  .el-icon-plus {
    font-size: 40px;
    border: 1px solid #cccccc;
    padding: 54px 30px;
  }
</style>
